import { useState, useEffect } from 'react'
import { post } from '../../services/api'
import vacaImagem from '../../assets/img/vaca.svg'
import porcoImagem from '../../assets/img/porco.svg'
import graficoImagem from '../../assets/img/grafico.webp'
import baleiaImagem from '../../assets/img/baleia-azul.svg'
import submarinoImagem from '../../assets/img/submarino.svg'

function CardAnimalRelatorio({ idRelatorio, nomeRelatorio, descricaoRelatorio, mesAno, idVendedor, status, regiao, cargo }) {

    const [isFetchingData, setIsFetchingData] = useState(false);
    const [dadosIndisponiveis, setDadosIndisponiveis] = useState(false);
    const [mensagemErro, setMensagemErro] = useState('Dados indisponíveis');

    useEffect(() => {
        setDadosIndisponiveis(false);
    }, [mesAno]);

    useEffect(() => {
        setDadosIndisponiveis(false);
    }, [idVendedor]);

    const abrirRelatorio = async () => {
        try {
            if (idVendedor || regiao) {
                if (idRelatorio == 1) {
                    const dadosRequisicaoVacaLeiteira = {
                        idVendedor: idVendedor,
                        mesAno: mesAno,
                    };
                    sessionStorage.setItem('dadosRequisicaoVacaLeiteira', JSON.stringify(dadosRequisicaoVacaLeiteira));
                    window.open('/vacaleiteira');
                }

                if (idRelatorio == 3) {
                    const novaAba = window.open('/trv', '_blank');
                    localStorage.setItem("carregandoTRV", true);
                    const mensagemCarregamento = cargo === 'VENDEDOR' ? 'Carregando Simulador de Salário' : 'Carregando TRV';
                    localStorage.setItem("mensagemCarregamentoTRV", mensagemCarregamento);

                    setIsFetchingData(true);

                    const response = await getRelatorio();

                    setIsFetchingData(false);
                    localStorage.removeItem("carregandoTRV");
                    localStorage.removeItem("mensagemCarregamentoTRV");
                    
                    if (!response.sucesso) {
                        localStorage.removeItem("trvDetalhe");
                        localStorage.removeItem("carregandoTRV");
                        localStorage.removeItem("mensagemCarregamentoTRV");
                        const mensagemErroTrv = response.mensagem ? response.mensagem : mensagemErro;
                        localStorage.setItem('erroTRV', mensagemErroTrv);
                        novaAba.location.href = '/trv';
                        setDadosIndisponiveis(true);
                        setMensagemErro(mensagemErroTrv);
                        return;
                    }

                    localStorage.removeItem('erroTRV');

                    const trvInfoUsuario = {
                        idVendedor: idVendedor,
                        mesAno: mesAno,
                        cargo: cargo,
                    };

                    response.trvInfoUsuario = trvInfoUsuario;
                    localStorage.setItem('trvDetalhe', JSON.stringify(response));
                    novaAba.location.href = '/trv';
                }

                if (idRelatorio == 4) {
                    const dadosRequisicaoOceanoAzul = {
                        idVendedor: idVendedor,
                        mesAno: mesAno,
                        cargo: cargo,
                        regiao: regiao,
                        visaoRede: false
                    };
                    sessionStorage.setItem('dadosRequisicaoOceanoAzul', JSON.stringify(dadosRequisicaoOceanoAzul));
                    window.open('/oceanoazul');
                }
            }

            if (idRelatorio == 2) {
                window.open('/painelbordo');
            }

            if (idRelatorio === 5) {
                const idVendedorUsuario = localStorage.getItem("idvendedorusuario");
                const dadosRequisicaoOceanoAzul = {
                    idVendedor: idVendedorUsuario,
                    mesAno: mesAno,
                    cargo: null,
                    regiao: regiao,
                    visaoRede: true
                };
                sessionStorage.setItem('dadosRequisicaoOceanoAzul', JSON.stringify(dadosRequisicaoOceanoAzul));
                window.open('/oceanoazul');
            }
        } catch (error) {
            setIsFetchingData(false);
        }
    };

    function getRelatorioRota() {
        if (idRelatorio == 1) {
            return 'vacaleiteira/getanimal';
        }

        if (idRelatorio == 3 && cargo === 'GERENTE_LOJA') {
            return 'trv/gerente';
        }

        if (idRelatorio == 3 && cargo === 'GERENTE_REGIONAL') {
            return 'trv/gerenteregional';
        }

        if (idRelatorio == 3 && cargo === 'VENDEDOR') {
            return 'trv/vendedor';
        }
    }

    function getImagem() {
        switch (idRelatorio) {
            case 1:
                return vacaImagem;
            case 2:
                return graficoImagem;
            case 3:
                return porcoImagem;
            case 4:
                return baleiaImagem;
            case 5:
                return submarinoImagem;    
        }
    }

    async function getRelatorio() {
        try {
            const [mes, ano] = mesAno.split('-');
            const requisicao = { regiao: regiao, vendedor: idVendedor, mes: mes, ano: ano, cargo: cargo };
            const response = await post('/' + getRelatorioRota(), requisicao);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    function statusDetalhes() {
        try {
            if (isFetchingData) {
                return 'Carregando detalhes...';
            } else if (dadosIndisponiveis) {
                return mensagemErro;
            } else {
                return 'Visualizar mais detalhes';
            }
        } catch (error) {
            console.error('Erro:', error.message);
        }
    }

    return (
        <div className="grid grid-cols-9 grid-rows-1 relative">
            <div className="col-span-9 md:col-span-3 bg-gradient-to-b from-white to-gray-c8 text-center font-bold text-[22px] text-gray-c3 py-4 px-6 grid z-10 shadow-animal rounded-tr-[10px] md:rounded-tr-none">
                <div className="self-center">
                    <img src={getImagem()} alt="Imagem" className="object-contain aspect-[3/4] max-w-full inline-block" />
                </div>
            </div>
            <div className="col-span-9 md:col-span-6 bg-gray-c4 px-4 pb-4 pt-[22px] grid rounded-tr-none md:rounded-tr-[10px]">
                <div className="">
                    <p className="font-light text-gray-c5 text-sm leading-none pb-3">{descricaoRelatorio}</p>
                    <h4 className="font-bold text-gray-c5 text-lg leading-none"><span className="text-2xl uppercase inline-block md:block pt-0 md:pt-1">{nomeRelatorio}</span></h4>
                </div>
                <div className="text-gray-c3 font-mulish font-medium text-[15px]">
                    <p className="">Status: {status}</p>
                </div>
            </div>
            <div className="col-span-9">
                <button
                    onClick={() => abrirRelatorio()}
                    className="rounded-b-[10px] w-full text-center inline-block bg-gradient-to-b from-green-c3 to-green-c4 py-[10px] font-medium text-base text-white leading-none"
                    disabled={isFetchingData || dadosIndisponiveis}
                >
                    {statusDetalhes()}
                </button>
            </div>
        </div>
    );
}

export default CardAnimalRelatorio